module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-prologue element-with-heading",
    attrs: {
      "id": "prologue"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("PROLOGUE")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "prologue-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("Even as she fell,")]), _vm._v(" arms flailing against gravity, cereal, milk, and orange juice tumbling with her, she thought she was dreaming.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ever since she’d arrived at the ReNew Adolescent Treatment Center, most of her dreams ended this way: a nightmarish hurtle through space, followed by jerking awake, eyes wide, gasping for breath, heart pounding so hard her pulse throbbed from fingers to toes.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A stunned hush filled the room as fifty-one other adolescents watched her fall to the floor, creating a colorful collage of her breakfast. One knee hit the blue linoleum. Hard. She bit her tongue against her cry of pain.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Rule Number One: No Names do not speak unless they are spoken to.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Her hand slapped onto a mushy pile of cornflakes and OJ, saving her from slamming face first, but even the pain couldn’t breach the numb exhaustion that made her brain clumsy and slow to admit reality.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("This is all just a dream")]), _vm._v(", a seductive voice whispered. Any second now, her alarm would go off, Mom would shriek at her to get her lazy ass out of bed, "), _c('i', [_vm._v("Now!")]), _vm._v(", or best of all, Dad would be home, rumbling at Mom, telling her to take it easy on the kid.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("How could it be a dream? The thought as sluggish as the rest of her body.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Rule Number Seven: No Names do not sleep without permission.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The other kids were a khaki blur surrounding her. Like her, they had no name, no identity, no reason to exist. Beyond them brightly colored posters mocked her with exhortations to “ReJoice!” and “ReFresh Your Spirit!”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Chairs scraped back and footsteps thudded, blood-red spots appearing in her peripheral vision as she thought about getting up, but the idea felt too far away to actually do anything about it. Part of her wanted to roll over, pull warm, soft covers up over her head, and ignore the dream.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Another part of her, the area of her brain in charge of survival, shouted at her that this wasn’t a dream and she needed to move, to run, run, run!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Rule Number Four: No Names do not leave or enter a room without permission.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Laughter cut through the fog. She looked up. Surrounded by a sea of red. Too late to save herself. Because this was no dream.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("This was hell.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a71849d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prologue.vue
// module id = 78
// module chunks = 0